// src/data/experience.js
export const experienceData = [
  {
    id: 1,
    title: {
      fr: "Développeur Java",
      en: "Java Developer"
    },
    company: "BJFT S.A.",
    period: {
      fr: "Mai 2025 - Présent",
      en: "May 2025 - Present"
    },
    description: {
      fr: "Conception et développement de microservices robustes avec Java Spring Boot pour systèmes de paiement et services financiers. Architecture orientée microservices avec communication sécurisée via REST et messaging (Kafka, RabbitMQ). Intégration de providers de paiement et APIs bancaires avec gestion d'authentification et tokens dynamiques. Déploiement et orchestration via Docker avec respect des standards PCI DSS et réglementations bancaires. Monitoring avancé avec ELK, Prometheus, Grafana pour disponibilité 24/7.",
      en: "Design and development of robust microservices with Java Spring Boot for payment systems and financial services. Microservices-oriented architecture with secure communication via REST and messaging (Kafka, RabbitMQ). Integration of payment providers and banking APIs with authentication management and dynamic tokens. Deployment and orchestration via Docker with compliance to PCI DSS standards and banking regulations. Advanced monitoring with ELK, Prometheus, Grafana for 24/7 availability."
    },
    skills: [
      "Java", "Spring Boot", "Microservices", "Kafka", "RabbitMQ", "Docker", "PostgreSQL", "MongoDB", "ELK Stack", "Prometheus", "Grafana"
    ],
    icon: "Server"
  },
  {
    id: 2,
    title: {
      fr: "Développeur Full Stack",
      en: "Full Stack Developer"
    },
    company: "Alshadows technologie",
    period: {
      fr: "Janvier 2025 - Mai 2025",
      en: "January 2025 - May 2025"
    },
    description: {
      fr: "Conception et développement fullstack de la plateforme Faroty Crowdfunding, de la première ligne de code jusqu'à la mise en production. Développement backend avec Spring Boot en architecture microservices, intégration du paiement Mobile Money (MTN, Orange) avec gestion de webhooks, et développement du frontend avec Next.js. Responsable du déploiement des applications.",
      en: "Full stack design and development of the Faroty Crowdfunding platform, from the first line of code to production deployment. Backend development with Spring Boot microservices architecture, Mobile Money payment integration (MTN, Orange) with webhook management, and frontend development with Next.js. Responsible for application deployment."
    },
    skills: [
      "Spring Boot", "Next.js", "Microservices", "Mobile Money", "Docker", "PostgreSQL", "JWT", "CI/CD"
    ],
    icon: "Server"
  },
  {
    id: 3,
    title: {
      fr: "Développeur Full Stack",
      en: "Full Stack Developer"
    },
    company: "LECKPA GROUP",
    period: {
      fr: "Octobre 2024 - Janvier 2025",
      en: "October 2024 - January 2025"
    },
    description: {
      fr: "Participation à un projet de développement d'une application web de gestion de news, visant à offrir une plateforme interactive et dynamique de diffusion d'informations en temps réel. Développement du backend de l'application en utilisant Django. Conception et développement du frontend avec Ionic Angular.",
      en: "Participation in the development of a news management web application, aiming to offer an interactive and dynamic platform for real-time information dissemination. Development of the application backend using Django. Design and development of the frontend with Ionic Angular."
    },
    skills: [
      "Django", "Ionic", "Angular", "PostgreSQL", "RESTful API"
    ],
    icon: "Laptop"
  },
  {
    id: 4,
    title: {
      fr: "Développeur Backend / Testeur Qualité (QA)",
      en: "Backend Developer / Quality Assurance (QA)"
    },
    company: "SIMPAY, Yaoundé",
    period: {
      fr: "Août 2023 - Octobre 2024",
      en: "August 2023 - October 2024"
    },
    description: {
      fr: "Participation au développement et à la maintenance d'une application de paiement en ligne, en concevant des microservices backend robustes et en mettant en place une stratégie de tests. Conception, développement et maintenance de microservices en Java avec Spring Boot. Mise en place de tests d'acceptation automatisés à l'aide de Selenium et Playwright. Configuration de GitHub Actions pour l'automatisation des tests et de déploiement continu.",
      en: "Participation in the development and maintenance of an online payment application, designing robust backend microservices and implementing a testing strategy. Design, development, and maintenance of microservices in Java with Spring Boot. Implementation of automated acceptance tests using Selenium and Playwright. Configuration of GitHub Actions for test automation and continuous deployment."
    },
    skills: [
      "Java", "Spring Boot", "Microservices", "Selenium", "Playwright", "GitHub Actions", "CI/CD"
    ],
    icon: "Database"
  },
  {
    id: 5,
    title: {
      fr: "Développeur Frontend Freelance",
      en: "Frontend Developer Freelancer"
    },
    company: {
      fr: "Indépendant",
      en: "Independent"
    },
    period: {
      fr: "Septembre 2023 - Juillet 2024",
      en: "September 2023 - July 2024"
    },
    description: {
      fr: "Développement d'un tableau de bord administrateur avec React Admin pour la gestion des utilisateurs et des transactions. Intégration des services backend. Collaboration étroite avec les équipes backend pour la définition des API nécessaires.",
      en: "Development of an admin dashboard with React Admin for user and transaction management. Integration of backend services. Close collaboration with backend teams for defining necessary APIs."
    },
    skills: [
      "React", "React Admin", "Material UI", "RESTful API", "JavaScript", "CSS"
    ],
    icon: "Code"
  }
];